const templateUrl = require('./select-shipping.html');

module.exports = function($stateProvider) {
  $stateProvider.state('shipping.edit', {
    resolve: {
      addresses: ['ogsdk.addressService', addressService => addressService.getAll({ pagination: { pageSize: 100 } }, { cache: true })]
    },
    views: {
      'shipping@': {
        templateUrl: templateUrl,
        controller: require('./select-shipping.controller'),
        controllerAs: '$ctrl'
      }
    }
  });
};

module.exports.$inject = ['$stateProvider'];
